export const CITIES_OF_INDIA = [
  "Mumbai", "Delhi", "Bengaluru", "Goa", "Pune", "Hyderabad", "Kolkata", 
  "Chennai", "Ahmedabad", "Jaipur", "Chandigarh", "Kochi", "Indore", "Surat", 
  "Lucknow", "Bhopal", "Visakhapatnam", "Patna", "Vadodara", "Ludhiana", 
  "Agra", "Nashik", "Varanasi", "Srinagar", "Amritsar", "Guwahati", "Ranchi",
  "Nagpur", "Noida", "Gurugram", "Faridabad", "Thane", "Navi Mumbai", "Kanpur",
  "Coimbatore", "Madurai", "Mysuru", "Mangaluru", "Thiruvananthapuram", "Vijayawada",
  "Bhubaneswar", "Dehradun", "Jodhpur", "Udaipur", "Raipur", "Jamshedpur",
  "Aurangabad", "Kolhapur", "Jalandhar", "Rajkot", "Shimla", "Pondicherry",
  "Shillong", "Gangtok", "Tirupati", "Warangal", "Gwalior", "Jabalpur", "Meerut"
];

// Nightlife cover photos per city (landing page hero) — pooled across all cities
const COVER_POOL = [
  "https://images.unsplash.com/photo-1566737236500-c8ac43014a8e?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1506157786151-b8491531f063?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1571266028243-d220c9c3bce5?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1524368535928-5b5e00ddc76b?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1501386761578-eac5c94b800a?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=1600&q=80"
];

export const CITY_COVERS = Object.fromEntries(
  CITIES_OF_INDIA.map((city, i) => [city, COVER_POOL[i % COVER_POOL.length]])
);
